<template>
  <div class="language-switcher">
    <select v-model="currentLanguage" @change="changeLanguage" class="language-select">
      <option value="zh">中文</option>
      <option value="en">English</option>
      <option value="ru">Русский</option>
    </select>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n();
    const currentLanguage = ref(locale.value);
    
    const changeLanguage = (event) => {
      const newLanguage = event.target.value;
      locale.value = newLanguage;
      currentLanguage.value = newLanguage;
      localStorage.setItem('language', newLanguage);
    };
    
    return {
      currentLanguage,
      changeLanguage
    };
  }
}
</script>

<style scoped>
.language-switcher {
  display: inline-block;
}

.language-select {
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid #515b70;
  background-color: #3a4559;
  color: white;
  font-size: 14px;
  cursor: pointer;
}

.language-select:focus {
  outline: none;
  border-color: #8ab4f8;
}

.language-select option {
  background-color: #2d3748;
  color: white;
}
</style>
